import React from 'react'
import Breadcrumbs from 'molecules/Breadcrumbs';
import ActionsWithFilter from 'organisms/ActionsWithFilter';
import AddFirmInitiativesDrawer from 'organisms/FirmInitiativesDrawer';
import FirmInitiativeListing from 'organisms/FirmInitiativeListing';
import AlertModal from 'molecules/AlertModal';
import AddDelegationDrawer from 'organisms/AddDelegationDrawer';
import BulkUploadDrawer from '@/organisms/BulkUploadDrawer';

const FirmInitiativeTemplate = ({
    firmInitiativeRmAdminDataModel = {},
    showDialog = '',
    setShowDialog = () => 0,
    onCloseInitiate = () => 0,
    onDelegateSubmit = () => 0,
    defaultValues = {},
    showLoading = false,
}) => {

    return (
        <>
            <div className='px-4 py-5'>
                <Breadcrumbs
                    items={firmInitiativeRmAdminDataModel.breadcrumbs}
                    customClass='mb-4'
                />
                <ActionsWithFilter
                    {...firmInitiativeRmAdminDataModel.filter}
                />
                <FirmInitiativeListing
                    firmInitiativeRmAdminDataModel={firmInitiativeRmAdminDataModel}
                    showLoading={showLoading}
                />
            </div>
            <AddFirmInitiativesDrawer
                show={firmInitiativeRmAdminDataModel.showFirmInitiativesDrawer}
                onClose={firmInitiativeRmAdminDataModel.onClosFirmInitiativesDrawer}
                isEdit={firmInitiativeRmAdminDataModel.isEdit}
                onAddFirmInitiatives={firmInitiativeRmAdminDataModel.onAddFirmInitiatives}
                defaultValue={firmInitiativeRmAdminDataModel.defaultValues}
                onEditFirmInitiatives={firmInitiativeRmAdminDataModel.onEditFirmInitiatives}
            />
            <BulkUploadDrawer 
                showBulkUploadDrawer={firmInitiativeRmAdminDataModel.openBulkUploadDrawer}
                title={'Bulk Upload Firm Initiatives'}
                desc={'Download the template first to bulk upload firm initiative'}
                download={firmInitiativeRmAdminDataModel.downloadTemplate}
                onHideBulkUploadDrawer= {firmInitiativeRmAdminDataModel.hideBulkUploadDrawer}
                onUpload={firmInitiativeRmAdminDataModel?.uploadFirmInitiativeBulkFile}
                receivedFiles= {firmInitiativeRmAdminDataModel?.receivedFiles}
                deleteFile={firmInitiativeRmAdminDataModel?.deleteFile}
                filesState={firmInitiativeRmAdminDataModel?.filesState}
                acceptExtensions={['xlsx', 'xls']}
                isDisabled={firmInitiativeRmAdminDataModel?.isDisabled}
            />
             {showDialog === 'close-initiative' && <AlertModal
                show={showDialog === 'close-initiative'}
                title="Close Firm Initiative?"
                description="Are you sure you want to close this Firm Initiative? Once closed, employees will no longer be able to express interest. Do you wish to continue?"
                onClose={() => setShowDialog('')}
                saveLabel='Continue'
                onSave={() => onCloseInitiate()}
                onCancel={() => setShowDialog('')}
            />}

            {
                showDialog === 'add-delegates-drawer' && (
                    <AddDelegationDrawer show='add-delegates-drawer' onClose={() => setShowDialog('')}
                        onSubmit={onDelegateSubmit} type="firmInitiative"
                        delegateActivityId={defaultValues?.id}
                        pageType={'Firm Initiative'}
                    />
                )
            }

        </>
    )
}

export default FirmInitiativeTemplate 